import React from 'react'

export interface PreviewActionProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  visible: boolean
  verticallyCentered?: boolean
}

export const PreviewAction: React.FC<PreviewActionProps> = ({
  visible,
  verticallyCentered,
  ...props
}) => {
  const baseClassName =
    'bg-red-600 border-none rounded-lg cursor-pointer text-center items-center text-white absolute text-[0.85rem] flex h-8 w-8 right-1 z-20 transition-opacity duration-200'

  const style: React.CSSProperties = {
    opacity: visible ? 1 : 0,
    marginTop: verticallyCentered ? '-1rem' : '0',
    top: verticallyCentered ? '50%' : '4px',
    pointerEvents: visible
      ? 'auto'
      : ('none' as React.CSSProperties['pointerEvents']), // Only allow interaction when visible
  }

  return (
    <button style={style} className={baseClassName} {...props}>
      {props.children}
    </button>
  )
}
